import { Grid } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import RutubeIcon from "../icons/RutubeIcon";
import VKIcon from "../icons/VKIcon";
import { getConfUrl, getTermsUrl } from "../routes/apiRoutes";

import style from "./FooterContent.module.css";

import {
  GithubOutlined,
  LinkedinFilled,
  MailFilled,
  PhoneFilled,
  TwitterOutlined,
  YoutubeFilled,
} from "@ant-design/icons";

const { useBreakpoint } = Grid;

function Contacts() {
  const { t, i18n } = useTranslation();
  const screens = useBreakpoint();

  const [year] = useState(() => new Date().getFullYear());
  const isRu = i18n.language === "ru";

  const websiteUrl = isRu ? "https://nextgis.ru" : "https://nextgis.com";
  const email = isRu ? "info@nextgis.ru" : "info@nextgis.com";

  return (
    <div className={style.contactsWrap}>
      <div style={{ whiteSpace: "nowrap" }}>
        <span>© {year}</span>{" "}
        <a
          className={style.link}
          href={websiteUrl}
          target="_blank"
          rel="noreferrer"
        >
          {t("footer.company")}
        </a>
      </div>

      <div className={style.iconsWrap}>
        {isRu ? (
          <>
            <a href="https://vk.com/nextgis" target="_blank" rel="noreferrer">
              <VKIcon className={style.icon} />
            </a>

            <a
              href="https://github.com/nextgis/"
              target="_blank"
              rel="noreferrer"
            >
              <GithubOutlined className={style.icon} />
            </a>

            <a
              href="https://rutube.ru/u/nextgis/"
              target="_blank"
              rel="noreferrer"
            >
              <RutubeIcon className={style.icon} />
            </a>
          </>
        ) : (
          <>
            <a
              href="https://twitter.com/nextgis"
              target="_blank"
              rel="noreferrer"
            >
              <TwitterOutlined className={style.icon} />
            </a>

            <a
              href="https://linkedin.com/company/nextgis"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedinFilled className={style.icon} />
            </a>

            <a
              href="https://github.com/nextgis/"
              target="_blank"
              rel="noreferrer"
            >
              <GithubOutlined className={style.icon} />
            </a>

            <a
              href="https://www.youtube.com/@nextgis_channel"
              target="_blank"
              rel="noreferrer"
            >
              <YoutubeFilled className={style.icon} />
            </a>
          </>
        )}

        <a className={style.link} href={`mailto:${email}`}>
          {!screens.lg ? (
            <MailFilled className={style.icon} />
          ) : (
            <span>{email}</span>
          )}
        </a>

        {isRu && (
          <a className={style.link} href="tel:+79687305252">
            {!screens.lg ? (
              <PhoneFilled className={style.icon} />
            ) : (
              <span>{`+7 (968) 730-52-52`}</span>
            )}
          </a>
        )}
      </div>
    </div>
  );
}

export function FooterContent() {
  const { t, i18n } = useTranslation();

  return (
    <div className={style.footerWrap}>
      <Contacts />

      <div className={style.legalWrap}>
        <a className={style.link} href={getTermsUrl(i18n.language)}>
          {t("footer.terms")}
        </a>
        <a className={style.link} href={getConfUrl(i18n.language)}>
          {t("footer.conf")}
        </a>
      </div>
    </div>
  );
}
